import { render, staticRenderFns } from "./lookDetail.vue?vue&type=template&id=833ade94&scoped=true&"
import script from "./lookDetail.vue?vue&type=script&lang=js&"
export * from "./lookDetail.vue?vue&type=script&lang=js&"
import style0 from "./lookDetail.vue?vue&type=style&index=0&id=833ade94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833ade94",
  null
  
)

export default component.exports